import styled from 'styled-components';

import {getColor, ms} from '../../../../styles';
import {Image} from '../../../../uikit/Image';
import {IndexRow} from '../../../../uikit/IndexRow';
import {Skeleton} from '../../../../uikit/Skeleton';
import {Text} from '../../../../uikit/Text';
import {View} from '../../../../uikit/View';
import {RefundsListItem} from '../RefundsListItem';

export const Container = styled(View)`
  flex-direction: column;
`;

export const RowSkeleton = styled(Skeleton)`
  height: ${ms(18)};
  margin-bottom: ${ms(16)};
`;

export const Row = styled(IndexRow)`
  margin-bottom: ${ms(16)};
`;

export const PaymentMethodContainer = styled(View)`
  flex-direction: row;
  align-items: center;
`;

export const CardContent = styled(View)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const CardBrand = styled(Image)`
  width: ${ms(50)};
  height: ${ms(30)};
`;

export const CardLastDigits = styled(Text)`
  font-size: ${ms(13)};
  line-height: ${ms(18)};
  letter-spacing: ${ms(-0.08)};
  color: ${getColor('text3')};
`;

export const RefundsContainer = styled(View)`
  flex-direction: column;
  padding-top: ${ms(20)};
`;

export const RefundsHeaderContainer = styled(View)`
  flex-direction: row;
  align-items: center;
  margin-bottom: ${ms(17)};
`;

export const RefundsHeader = styled(Text).attrs({weight: 'bold'})`
  font-size: ${ms(16)};
  line-height: ${ms(22)};
  letter-spacing: ${ms(-0.46)};
  margin-right: ${ms(10)};
`;

export const RefundsStatusContainer = styled(View)`
  height: ${ms(20)};
  border-radius: ${ms(4)};
  align-items: center;
  justify-content: center;
  padding: 0 ${ms(6)};
  background-color: ${getColor('background10')};
`;

export const RefundsStatus = styled(Text)`
  font-size: ${ms(12)};
  letter-spacing: ${ms(-0.41)};
  color: ${getColor('text2')};
`;

const SRefundsListItem = styled(RefundsListItem)`
  margin-bottom: ${ms(12)};
`;

export {SRefundsListItem as RefundsListItem};
